import * as React from 'react';
import { StyledIframe } from './CreditAppIframe.styles';
import type { CreditAppIframeProps } from '../types';

/**
 * Credit App Iframe Component
 * Renders the credit application iframe with consistent styling
 */
export const CreditAppIframe: React.FC<CreditAppIframeProps> = ({ src }) => {
    return <StyledIframe id="creditapp-iframe" className="creditapp-activity-iframe" src={src} title="Credit Application" />;
};
